import {ACTION_CODE} from './_actionCode';
import {CustomerCategoryService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
import { UserState } from '../../reducers/UserReducer';

const FUNCTION_CODE = 'GET_ALL_CUSTOMER_CATEGORIES';

export async function getAllCustomerCategories(
    userData: UserState["userProfileData"],
    params = '',
    page = 1,
) {
    try {
        LoggerService.logInfo('Action - getAllCustomerCategories - Start');

        const getAllCustomerCategoriesResult = await CustomerCategoryService.getAllCustomerCategories(userData, params, page);

        LoggerService.logInfo('Action - getAllCustomerCategories - End - Success');

        return ResultModel.newSuccessResult(getAllCustomerCategoriesResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - getAllCustomerCategories - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récuperation de la liste des catégories client.',
            error: error
        });

        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
